/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `warning` - 경고 임계값
 * `limit_exceeded` - 한도 초과
 * `estimated_exceeded` - 예상 초과
 */
export type AlertTypeEnum = (typeof AlertTypeEnum)[keyof typeof AlertTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlertTypeEnum = {
  warning: "warning",
  limit_exceeded: "limit_exceeded",
  estimated_exceeded: "estimated_exceeded",
} as const;
